<template>
  <div class="d-flex align-items-center justify-content-center vh-100 bg-dark text-white">
    <div class="text-center">
      <div class="spinner-border text-warning mb-3" role="status"></div>
      <p class="font-weight-bold">{{ $currentLocale === 'id' ? 'Mengarahkan ke Portal Gamiteam...' : 'Redirecting to Gamiteam Portal...' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  mounted() {
    const token = this.$store?.state?.authToken || localStorage.getItem('authToken');
    if (token) {
      this.$router.replace('/dashboard');
    } else {
      this.$router.replace('/login');
    }
  }
}
</script>